import Cookies from 'js-cookie';

export const getLocalhostAu = () => {
  try {
    const fromCookie = Cookies.get('localhost_au');
    if (fromCookie) return fromCookie;

    if (typeof window !== 'undefined' && window.localStorage) {
      const fromStorage = window.localStorage.getItem('localhost_au');
      if (fromStorage) return fromStorage;
    }
  } catch (e) {
    console.error('Failed to read localhost_au:', e);
  }
  return null;
};

export const getAu = () => {
  try {
    const raw = Cookies.get('_au');

    if (!raw) return null;
    
    const trimmed = raw.trim();
    if (trimmed.startsWith('{')) {
      try {
        return JSON.parse(trimmed);
      } catch (e) {
        return null;
      }
    }
    return trimmed;
  } catch (e) {
    console.error('Failed to read _au:', e);
  }
  return null;
};

export const getOrgId = () => {
  try {
    const fromCookie = Cookies.get('_co');
    if (fromCookie) return fromCookie;

    if (typeof document !== 'undefined') {
      const el = document.getElementById('_co');
      if (el && el.value) return el.value;
    }
  } catch (e) {
    console.error('Failed to read org_id:', e);
  }
  return null;
};

export const getExzeoId = () => {
  try {
    const fromCookie = Cookies.get('exzeoid');
    if (fromCookie) return fromCookie;
  } catch (e) {
    console.error('Failed to read exzeoid:', e);
  }
  return null;
};

export const isLocalhostWithDevToken = () => {
  if (typeof window === 'undefined') return false;
  const isLocalhost = window.location.href.includes('localhost');
  const hasDevToken = !!getLocalhostAu();
  return isLocalhost && hasDevToken;
};
